import NumberFormat, { NumberFormatProps, NumberFormatValues } from 'react-number-format';
import React, { useRef } from 'react';

interface NumberInputProps extends Omit<NumberFormatProps, 'onValueChange' | 'getInputRef'> {
  onChange: (event: { target: { name: string; value: any } }) => void;
  usedValue?: keyof NumberFormatValues;
  name: string;
}

export const NumericInput = React.forwardRef<NumberFormat, NumberInputProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, name, usedValue = 'floatValue', ...other } = props;
    const inputValue = useRef<string | number | undefined>();

    function handleInputChange(e: { target: { name: string; value: string;}}) {
      onChange({...e, target: {name, value: inputValue.current}});
    }

    function onValueChange(values: NumberFormatValues) {
      inputValue.current = values[usedValue];
    }

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={onValueChange}
        onChange={handleInputChange}
       />
    );
  },
);

